import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { SectionHeader } from "./Reveal";
import { PROCESO } from "../../data/site";
import { EASE } from "../../lib/motion";

export default function Timeline() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.75", "end 0.6"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 70, damping: 22 });

  return (
    <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
      <div>
        <SectionHeader
          eyebrow="Proceso de trabajo"
          title="Un camino claro, de la idea a la operación."
          description="Trabajamos en fases con entregables visibles para que tu organización siempre sepa dónde está parada."
        />
      </div>

      <div ref={ref} className="relative pl-10" data-testid="process-timeline">
        <div className="absolute left-[7px] top-2 h-full w-px bg-border" aria-hidden="true" />
        <motion.div
          style={{ scaleY }}
          className="absolute left-[7px] top-2 h-[calc(100%-16px)] w-px origin-top bg-gradient-to-b from-brand to-electric"
          aria-hidden="true"
        />
        <div className="flex flex-col gap-10">
          {PROCESO.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6, delay: 0.05, ease: EASE }}
              className="relative"
              data-testid={`process-step-${step.num}`}
            >
              <span className="absolute -left-10 top-1 flex h-4 w-4 items-center justify-center">
                <span className="h-2.5 w-2.5 rounded-full border-2 border-electric bg-background" />
              </span>
              <div className="group flex flex-col gap-1 rounded-2xl border border-transparent p-1 transition-all duration-300 hover:rounded-2xl hover:border-border hover:bg-card hover:p-5">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-sm font-semibold text-electric">{step.num}</span>
                  <h3 className="font-display text-lg font-semibold sm:text-xl">{step.title}</h3>
                </div>
                <p className="ml-0 text-sm text-muted-foreground sm:ml-9">{step.desc}</p>
              </div>
              {i < PROCESO.length - 1 && <span className="sr-only">Siguiente fase</span>}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
